import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-02c94d18"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "detail"
};
var _hoisted_2 = {
  class: "box1"
};
var _hoisted_3 = {
  class: "boxTop"
};
var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = {
  class: "time"
};
var _hoisted_6 = {
  class: "space"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "b-btm"
  }, null, -1);
});

var _hoisted_8 = {
  class: "word"
};
var _hoisted_9 = {
  class: "imgPreview"
};
var _hoisted_10 = {
  key: 0
};
var _hoisted_11 = {
  key: 0,
  class: "detail"
};
var _hoisted_12 = {
  class: "box2"
};
var _hoisted_13 = {
  class: "boxTop"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, " 党委书记 ", -1);
});

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "b-btm"
  }, null, -1);
});

var _hoisted_16 = {
  class: "word"
};
var _hoisted_17 = {
  class: "imgPreview"
};
var _hoisted_18 = {
  key: 1,
  class: "huifu"
};

var _hoisted_19 = /*#__PURE__*/_createTextVNode(" 回复 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_image = _resolveComponent("el-image");

  var _component_el_button = _resolveComponent("el-button");

  var _directive_debounce = _resolveDirective("debounce");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "书记信箱",
    back: true
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.detail.title), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.detail.createTime), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.detail.typeId == 1 ? "建议" : _ctx.detail.typeId == 2 ? "咨询" : _ctx.detail.typeId == 3 ? "投诉" : "投诉"), 1), _hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.detail.sendContent), 1), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, function (item, index) {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      key: item,
      class: "demo-image__preview",
      onClick: _cache[0] || (_cache[0] = //@ts-ignore
      function () {
        return _ctx.handleRemove && _ctx.handleRemove.apply(_ctx, arguments);
      })
    }, [_createVNode(_component_el_image, {
      style: {
        "width": "100px",
        "height": "100px"
      },
      src: _ctx.baseUrl + item,
      "preview-src-list": _ctx.srcList,
      "initial-index": index,
      fit: "cover",
      "z-index": "99999"
    }, null, 8, ["src", "preview-src-list", "initial-index"])], 512)), [[_vShow, _ctx.detail.img]]);
  }), 128))])])])]), _ctx.detail.mailboxStatus ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_ctx.detail.delFlag == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.replyDetail.replyContent), 1), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.replyImg, function (item, index) {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      key: item,
      class: "demo-image__preview"
    }, [_createVNode(_component_el_image, {
      style: {
        "width": "100px",
        "height": "100px"
      },
      src: _ctx.baseUrl + item,
      "preview-src-list": _ctx.srcList1,
      "initial-index": index,
      fit: "cover",
      "z-index": 100000
    }, null, 8, ["src", "preview-src-list", "initial-index"])], 512)), [[_vShow, _ctx.replyDetail.img]]);
  }), 128))])])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.detail.person == true ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_ctx.detail.mailboxStatus == 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    type: "primary",
    onClick: _ctx.getLetter
  }, {
    default: _withCtx(function () {
      return [_hoisted_19];
    }),
    _: 1
  }, 8, ["onClick"])), [[_directive_debounce]]) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
}